var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1463 0H1.68209C0.744926 0 0 0.768956 0 1.68209V17.4937C0 18.4309 0.768956 19.1758 1.68209 19.1758H21.1222C22.0594 19.1758 22.8043 18.4069 22.8043 17.4937V1.68209C22.8284 0.744926 22.0594 0 21.1463 0ZM7.20896 1.73015C7.61747 1.73015 7.92985 2.06657 7.92985 2.45105C7.92985 2.85955 7.59344 3.17194 7.20896 3.17194C6.80045 3.17194 6.48806 2.83552 6.48806 2.45105C6.48806 2.04254 6.80045 1.73015 7.20896 1.73015ZM4.99821 1.73015C5.40672 1.73015 5.71911 2.06657 5.71911 2.45105C5.71911 2.85955 5.38269 3.17194 4.99821 3.17194C4.5897 3.17194 4.27732 2.83552 4.27732 2.45105C4.27732 2.04254 4.61373 1.73015 4.99821 1.73015ZM2.78746 1.73015C3.19597 1.73015 3.50836 2.06657 3.50836 2.45105C3.50836 2.85955 3.17194 3.17194 2.78746 3.17194C2.37896 3.17194 2.06657 2.83552 2.06657 2.45105C2.06657 2.04254 2.40299 1.73015 2.78746 1.73015ZM21.2664 17.4937C21.2664 17.5658 21.2184 17.6139 21.1463 17.6139H1.68209C1.61 17.6139 1.56194 17.5658 1.56194 17.4937V4.92612H21.2664V17.4937Z",
    fill: "#706D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60311 15.3776C8.69923 15.4737 8.86744 15.4737 8.96356 15.3776L10.093 14.2482C10.1891 14.1521 10.1891 13.9839 10.093 13.8878L7.49774 11.2685L10.093 8.67327C10.1891 8.57715 10.1891 8.40894 10.093 8.31282L8.96356 7.18342C8.86744 7.0873 8.69923 7.0873 8.60311 7.18342L4.71027 11.1003C4.61415 11.1964 4.61415 11.3646 4.71027 11.4607L8.60311 15.3776Z",
    fill: "#706D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7371 14.2482L13.8665 15.3776C13.9627 15.4737 14.1309 15.4737 14.227 15.3776L18.1438 11.4607C18.24 11.3646 18.24 11.1964 18.1438 11.1003L14.227 7.18342C14.1309 7.0873 13.9627 7.0873 13.8665 7.18342L12.7371 8.31282C12.641 8.40894 12.641 8.57715 12.7371 8.67327L15.3324 11.2685L12.7371 13.8878C12.641 13.9839 12.641 14.1521 12.7371 14.2482Z",
    fill: "#706D9D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.df0dd9b606e89fb81f561dfbb636e2d2.svg";
export { ForwardRef as ReactComponent };